import { createAlgoliaFilters, AlgoliaFilterOperator } from "./create-algolia-filters.js";
import { getProductAttributesByFacets } from "./get-product-attributes-from-facets.js";
const getGraphAlgoliaFilters = (product, activeVariant, facets, activeSku, locale) => {
  const masterVariantSku = { id: "masterVariant.sku", value: activeSku };
  const variantSkus = product.variants.map((variant) => ({
    id: "masterVariant.sku",
    value: variant.sku
  })).filter((v) => v.value !== masterVariantSku.value);
  const excludedSkus = createAlgoliaFilters(
    [masterVariantSku, ...variantSkus],
    AlgoliaFilterOperator.AND_NOT,
    AlgoliaFilterOperator.NOT
  );
  const attributes = getProductAttributesByFacets(facets, activeVariant.specifications, locale);
  const strictAttributes = attributes.filter((attribute) => attribute.type === "strict");
  const filters = strictAttributes.length > 0 ? `${createAlgoliaFilters(strictAttributes, AlgoliaFilterOperator.AND)} ${AlgoliaFilterOperator.AND} ${excludedSkus}` : excludedSkus;
  const optionalAttributes = attributes.filter((attribute) => attribute.type === "optional");
  const optionalFilters = createAlgoliaFilters(optionalAttributes);
  return { filters, optionalFilters };
};
export {
  getGraphAlgoliaFilters
};
//# sourceMappingURL=get-graph-algolia-filters.js.map
